document.addEventListener("DOMContentLoaded", function(event) {
    var acc = document.getElementsByClassName("accordion");

    for (var i = 0; i < acc.length; i++) {
      acc[i].onclick = function() {
        // Toggle the 'active' class on the clicked accordion
        this.classList.toggle("active");

        // Toggle the 'show' class on the corresponding panel
        var panel = this.nextElementSibling;
        if (panel) {
          panel.classList.toggle("show");
        }
      }
    }
  });